<template>
    <div>
        <section class="section-title-page  container-fluid" style="background-image: url('/img/bg_tramite.jpg');">
            <div class="container">
                <div class="wrapper">
                    <h1>Mesa<small style="font-weight: 300;"> de Partes</small></h1>
                    <span>
                        Volver <i class="fa fa-angle-right mx-1"></i>
                        <a :href="'/servicios'">Servicios</a>
                    </span>
                </div>
            </div>
        </section>
        <section class="section-page container-fluid">
            <div class="container d-flex">
                <div class="section-collapse" :class="{ active: activeSection === 1 }" @click="toggleSection(1)">
                    <p class="m-0"><i class="fa-solid fa-dashboard mr-2"></i>Realizar trámite</p>
                </div>
                <div class="section-collapse" :class="{ active: activeSection === 2 }" @click="toggleSection(2)">
                    <p class="m-0"><i class="fa-solid fa-search mr-2"></i>Consultar trámite</p>
                </div>
            </div>
            <div class="container mesa-wrapper my-3">
                <div class="collapse" :class="{ show: activeSection == 1}">
                    <div class="d-flex">
                        <div class="col-md-5 bg-white rounded px-4 py-4 mb-4" style="text-align: justify;">
                            <h5 class="text-black"><small><i class="fa fa-info-circle"></i> <strong>Información necesaria</strong></small></h5>
                            <hr>
                            <p>
                                Ponemos a disposición de nuestros colegiados, empresas y público en general, nuestra
                                plataforma "Mesa virtual", con la finalidad de facilitar la presentación y recepción de
                                documentos
                                de manera virtual.
                                Tenga en cuenta que usted, será el responsable directo del contenido y
                                registro de
                                información, así mismo de los documentos que remita adjunto al presente formulario.
                                <br> <br> <strong>Consideraciones a tener en cuenta:
                                </strong>
                            <ul style="padding-left: 20px; text-align:justify">
                                <li><b>Horario disponible</b>: {{empresa.horario_atencion}}</li>
                                <li>La plataforma no estará disponible en días feriados.</li>
                                <li>Una vez registrado su trámite, se le notificará el código asignado a su correo, el
                                    mismo que le permitirá hacer el seguimiento a su solicitud.</li>
                                <li>Para poder hacer el seguimiento a su trámite, deberá ingresar a la opción “Consultar
                                    Trámite”.
                                </li>
                            </ul>
                            </p>
                        </div>
                        <div class="col-md-7">
                            <form class="form-contact py-4">
                                <div class="d-flex mb-3 border-bottom">
                                    <p class="text-brown">(*) Todos los campos son obligatorios</p>
                                </div>
                                <div class="d-flex mesa">
                                    <div class="form-group col-3 px-0 pr-2 input-icon">
                                        <label for="email" class="required">DNI</label>
                                        <div class="input-group">
                                            <span class="input-group-text" >
                                                <i class="fa fa-id-card" aria-hidden="true"></i>
                                            </span>
                                            <input type="text" required maxlength="8" ref="nro_doc" placeholder="01100001" class="form-control" @keypress="isNumber($event)">
                                        </div>
                                        <span v-if="errores.doc_identidad!=''" class="text-danger" role="alert">{{errores.doc_identidad}}</span>
                                    </div>

                                    <div class="form-group col-9 px-0 input-icon">
                                        <label for="name" class="required">Nombres y apellidos</label>
                                        <div class="input-group">
                                            <span class="input-group-text" >
                                                <i class="fa fa-user" aria-hidden="true"></i>
                                            </span>
                                            <input type="text" required class="form-control" ref="nombres" placeholder="Ingresar Nombres y Apellidos tal como está en su DNI" id="name" @keypress="isLetter($event)">
                                        </div>
                                        <span v-if="errores.nombres!=''" class="text-danger" role="alert">{{errores.nombres}}</span>
                                    </div>
                                </div>
                                <div class="d-flex">
                                    <div class="form-group col-3 px-0 pr-2  input-icon">
                                        <label for="email" class="required">Teléfono Móvil</label>
                                        <div class="input-group">
                                            <span class="input-group-text" >
                                                <i class="fa fa-phone" aria-hidden="true"></i>
                                            </span>
                                            <input type="text" required maxlength="9" ref="telefono" class="form-control" placeholder="942000000" @keypress="isNumber($event)">
                                        </div>
                                        <span v-if="errores.telefono!=''" class="text-danger" role="alert">{{errores.telefono}}</span>
                                    </div>
                                    <div class="form-group col-9 px-0 input-icon">
                                        <label for="email" class="required">Correo electrónico</label>
                                        <div class="input-group">
                                            <span class="input-group-text" >
                                                <i class="fa fa-envelope" aria-hidden="true"></i>
                                            </span>
                                            <input type="email" required ref="correo" class="form-control" @keypress="isMail($event)" placeholder="example@example.com">
                                        </div>
                                        <span v-if="errores.correo!=''" class="text-danger" role="alert">{{errores.correo}}</span>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label for="subject" class="required">Asunto</label>
                                    <input type="text" required ref="asunto" class="form-control" placeholder="Digite el asunto o titulo de su consulta" id="subject">
                                    <span v-if="errores.asunto!=''" class="text-danger" role="alert">{{errores.asunto}}</span>
                                </div>
                                <div class="form-group">
                                    <label for="message" class="required">Mensaje</label>
                                    <textarea class="form-control" ref="mensaje" rows="2" placeholder="Aquí su mensaje..."></textarea>
                                    <span v-if="errores.mensaje!=''" class="text-danger" role="alert">{{errores.mensaje}}</span>
                                </div>

                                <div class="form-group">
                                  <label for="anexo_documento_solicitado">Adjuntar Anexos[<b>doc, xls, pdf, jpg, png</b>] (Ojo: <span style="font-size:12px;"><i>En caso de tener anexos</i></span>)</label>
                                  <div class="custom-file">
                                      <input id="archivo" @change="CapturarNombreAnexo" type="file" ref="file_anexo" accept=".pdf,.jpg,.doc,.docx,.png,.xls,.xlsx" class="custom-file-input required" >
                                      <label id="archivoLabel" class="custom-file-label">{{prev_file_upload_anexo}}</label>
                                  </div>
                                </div>

                                <div class="form-group">
                                  <label for="asunto" >Anexos Adjuntos</label>
                                  <div style="max-height: 120px; overflow-y:auto;">
                                    <table id="table_anexos" class="table table-striped mb-0 table-hover">
                                      <tbody>
                                          <tr v-for="(val, key) in anexos_solicitud" :key="key">
                                              <td>{{val.name}}</td>
                                              <td>
                                                  <button type="button" @click="deleteRow(key)" class="btn btn-xs btn-danger">
                                                      <i class="fa fa-trash"></i>
                                                  </button>
                                              </td>
                                          </tr>
                                          <tr v-if="anexos_solicitud.length<1">
                                              <td colspan="2" class="text-left text-info"><i>Sin anexos...</i></td>
                                          </tr>
                                      </tbody>
                                    </table>
                                  </div>
                                </div>

                                <div class="form-group d-flex mb-0 justify-content-between align-items-center">
                                    <button type="button" @click="enviarMail" class="btn btn-sm bg-brown-opac text-white px-5 font-weight-bold">Enviar</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                <div class="collapse" :class="{ show: activeSection == 2 }">
                    <div class="bg-white rounded">
                        <div class="p-3">
                            <p class="m-0">(*) Ingrese el <strong>código</strong> de su trámite para verificar su progreso y obtener una información detallada.</p>
                        </div>
                        <div class="form-contact px-3 pt-0 search d-flex w-100 justify-content-center">
                            <div class="form-group px-0 mb-0 d-flex col-9">
                                <div class="caja-input" style="border-top-right-radius: 0px !important;border-bottom-right-radius: 0px !important;">
                                    <span>CMVSM-</span>
                                    <input type="text" autofocus ref="numero_tramite" required class="form-control">
                                </div>
                            </div>
                            <div class="form-group px-0 mb-0 col-3 d-flex justify-content-between align-items-center">
                                <button class="btn w-100 h-100 bg-brown-opac text-white px-5 font-weight-bold"
                                    @click="seguimiento" style="border-top-left-radius: 0px !important;border-bottom-left-radius: 0px !important;">Consultar
                                </button>
                            </div>
                        </div>
                        <span v-if="errores.numero_tramite!=''" class="text-danger form-contact px-3 w-100 d-flex justify-content-center" role="alert">{{errores.numero_tramite}}</span>
                    </div>
                    <div id="viewTramite">
                        <div class="description w-100" v-if="band_seguimiento">
                          <p class="m-0 esperanding">Esperando consulta...</p>
                        </div>
                        <div class="not-found" v-show="seguimiento_tramite.length<1">
                          <p class="m-0">No se encontraron resultados <i class="fa far fa-sad-cry"></i></p>
                        </div>
                        <div class="showTable rounded bg-white mt-2 p-3 w-100" v-show="seguimiento_tramite.length>0">
                            <table class="table">
                                <thead class="bg-black text-white">
                                    <tr>
                                        <th class="text-center">Descripción</th>
                                        <th class="text-center">Fecha</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(value, key) in seguimiento_tramite" :key="key">
                                        <td class="text-center">
                                            <span class="badge" :style="{'background': value.bg, 'color':'white'}">{{value.estado}}</span>
                                        </td>
                                        <td class="text-center">{{value.fecha}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import axios from 'axios';
import { mapState, mapMutations } from "vuex";
export default {
  name: "mesa_partes_virtual",
  computed: {
    ...mapState(["empresa"]),
  },
  data() {
    return {
      activeSection: 1,
      errores: {
        doc_identidad: "",
        nombres: "",
        telefono: "",
        correo: "",
        mensaje: "",
        asunto: "",
        numero_tramite:"",
      },
      seguimiento_tramite:[],
      band_seguimiento: true,
      anexos_solicitud:[],
      prev_file_upload:"No seleccionó ningún archivo",
      prev_file_upload_anexo:"Seleccione sus anexos PDF",
      file_select:"formato_acceso_inf_publico.pdf",
    };
  },

  methods: {
    ...mapMutations(["setLoading"]),
    toggleSection(section) {
      this.activeSection = section;
      this.active = section;
    },
    CapturarNombreAnexo(){
      this.prev_file_upload_anexo         = "Añadir mas anexos PDF";
      console.log(this.$refs.file_anexo.files[0]);
      this.anexos_solicitud.push(this.$refs.file_anexo.files[0]);
    },
    enviarMail() {
      var self = this;
      if (this.$refs.nro_doc.value == "") {
        this.$refs.nro_doc.focus();
        this.errores.doc_identidad = "Campo obligatorio";
        return;
      } else if (this.$refs.nro_doc.value.length < 8) {
        this.$refs.nro_doc.focus();
        this.errores.doc_identidad = "Requerido 8 dígitos";
        return;
      } else {
        this.errores.doc_identidad = "";
      }

      if (this.$refs.nombres.value == "") {
        this.$refs.nombres.focus();
        this.errores.nombres = "Campo obligatorio";
        return;
      } else {
        this.errores.nombres = "";
      }

      if (this.$refs.telefono.value == "") {
        this.$refs.telefono.focus();
        this.errores.telefono = "Campo obligatorio";
        return;
      } else if (this.$refs.telefono.value.length < 8) {
        this.$refs.telefono.focus();
        this.errores.telefono = "Requerido 9 dígitos";
        return;
      } else {
        this.errores.telefono = "";
      }

      if (this.$refs.correo.value == "") {
        this.$refs.correo.focus();
        this.errores.correo = "Campo obligatorio";
        return;
      } else if (!this.validEmail(this.$refs.correo.value)) {
        this.$refs.correo.focus();
        this.errores.correo = "Ingrese correo válido";
        return;
      } else {
        this.errores.correo = "";
      }

      if (this.$refs.asunto.value == "") {
        this.$refs.asunto.focus();
        this.errores.asunto = "Campo obligatorio";
        return;
      } else {
        this.errores.asunto = "";
      }

      if (this.$refs.mensaje.value == "") {
        this.$refs.mensaje.focus();
        this.errores.mensaje = "Campo obligatorio";
        return;
      } else {
        this.errores.mensaje = "";
      }

      self.setLoading(true);
      let formData = new FormData();
      formData.append("doc_identidad", this.$refs.nro_doc.value);
      formData.append("remitente", this.$refs.nombres.value);
      formData.append("telefono_movil", this.$refs.telefono.value);
      formData.append("correo", this.$refs.correo.value);
      formData.append("asunto", this.$refs.asunto.value);
      formData.append("mensaje", this.$refs.mensaje.value);
      this.anexos_solicitud.map((v, k)=>{
        formData.append('anexos[]', v); //PARAMETRO PARA GORESAM
      });

      axios.post(window.baseUrl+"ws_main/vitual_parts_mail", formData,{ header:{'Content-Type' : 'multipart/form-data'}})
      .then((res)=>{
        if (res.data.status) {
            this.alertSuccess(res.data.msg, function () {
              self.setLoading(true);
              location.reload();
            });
          } else {
            this.alertWarning(res.data.msg, function () {
              location.reload();
            });
          }
      }).catch((error) => {
          let mensajeObj = error.toJSON();
          let mensajeDat = error.response.data;
          if(error.response.status==500){
            self.alertWarning(mensajeDat.msg);
          }else{
            self.alertWarning(mensajeDat.message);
          }
      })
      .finally(() => {
        this.setLoading(false);
      });
    },
    seguimiento(){
      var self = this;
      if (this.$refs.numero_tramite.value == "") {
        this.$refs.numero_tramite.focus();
        this.errores.numero_tramite = "Campo obligatorio";
        return;
      } else if (this.$refs.numero_tramite.value.length < 8) {
        this.$refs.numero_tramite.focus();
        this.errores.doc_identidad = "Requerido 8 dígitos";
        return;
      } else {
        this.errores.doc_identidad = "";
      }

      self.setLoading(true);
      let formData = new FormData();
      formData.append("numero_tramite", this.$refs.numero_tramite.value);

      this.$http
        .post("ws_main/vitual_parts_follow", formData)
        .then((res) => {
          this.band_seguimiento = false;
          if (res.data.status) {
            this.seguimiento_tramite = res.data.data;
          } else {
            this.alertWarning(res.data.msg, function () {
              location.reload();
            });
          }
        })
        .catch((error) => {
          console.log(error);
					//self.alertWarning(error);
				})
        .finally(() => {
          this.setLoading(false);
        });
    },
    deleteRow(index){
      this.users.splice(index, 1);
    },
  },
};
</script>

<style>
  .section-collapse.active {
    transition: all 0.3s;
    background-color: var(--color-brown); 
    color: #fff; 
  }

  #table_anexos tbody tr td{
    padding: .35rem;
  }
</style>